import { render, staticRenderFns } from "./EnvironmentalImpact.vue?vue&type=template&id=2e849f7a&scoped=true"
import script from "./EnvironmentalImpact.vue?vue&type=script&lang=js"
export * from "./EnvironmentalImpact.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentalImpact.vue?vue&type=style&index=0&id=2e849f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e849f7a",
  null
  
)

export default component.exports